import { Add, KeyboardArrowDown, MoreHorizOutlined } from "@mui/icons-material";
import { Button, Menu, MenuItem, Select } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
 
} from "@mui/material";

import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import React, { useEffect, useState } from "react";
import AddChannelModal from "../modals/AddChannelModal";
import Edit from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import EditChannelModal from "../modals/EditChannelModal";
import ChannelAddedModal from "../modals/ChannelAddelModal";
import ChannelPendingModal from "../modals/ChannelPendingModal";
import AddToSlackModal from "../modals/AddUserToSlack";
import ChannelUpdatedModal from "../modals/ChannelUpdatedModal";
import { formatTimestamp } from '../utils/formattimestamp';
import RemoveChannelModal from "../modals/RemoveChannelModal";
import ChannelList from "../reusables/ChannelList";


const Channels = () => {
    const [openAddChannelModal, setOpenAddChannelModal] = useState(false)
    const [channels, setChannels] = useState(JSON.parse(localStorage.getItem("organization"))?.channels?.L || [])
 
    function getUrlParam(paramName, url = window.location.href) {
      // Create a URL object
      const urlObj = new URL(url);
      
      // Get the value of the specified parameter
      const paramValue = urlObj.searchParams.get(paramName);
    
      return paramValue;
    }

    const [code ,setCode] = useState()

    useEffect(()=> {
      let c = getUrlParam("code")
      setCode(c) 
      if(c){
        setOpenChannelAddedModal(true)
      }
    },[])

    const [openChannelAddedModal,setOpenChannelAddedModal] = useState(false)
    const [openChannelPendingModal,setOpenChannelPendingModal] = useState(false)
    const [addToSlackModal, setOpenAddToSlackModal] = useState(false)
    const[ channelUpdatedModal, setOpenChannelUpdatedModal] = useState(false)

    const [channel_id, setChannelId] = useState(null)

   

  return (
    <div className="pt-7 px-4">
      <div className="flex justify-between items-center">
      <div className="lg:text-[22px] text-[20px] font-bold mb-4 lg:mt-0 mt-8 ">
        Channels
      </div>
         {code ? ( <ChannelAddedModal setChannels={setChannels} open={openChannelAddedModal} setOpen={setOpenChannelAddedModal} code={code}  />): (
           <ChannelAddedModal setChannels={setChannels} open={openChannelAddedModal} setOpen={setOpenChannelAddedModal} />
         )}
          <ChannelUpdatedModal open={channelUpdatedModal} setOpen={setOpenChannelUpdatedModal}/>
          <ChannelPendingModal open={openChannelPendingModal} setOpen={setOpenChannelPendingModal} />
          <AddToSlackModal open={addToSlackModal} setOpen={setOpenAddToSlackModal} channel_id={channel_id} setChannelId={setChannelId} />
        <AddChannelModal open={openAddChannelModal} setOpen={setOpenAddChannelModal}
        channelAddedModal={openChannelAddedModal} setOpenChannelAddedModal={setOpenChannelAddedModal}
        channelPendingModal={openChannelPendingModal} setOpenChannelPendingModal={setOpenChannelPendingModal}
      addToSlackModal={addToSlackModal} setOpenAddToSlackModal={setOpenAddToSlackModal}
      setChannelId={setChannelId}
        channels={channels} setChannels={setChannels} />
        <div className="">
          <Button
            variant="contained"
            color="primary"
            sx={{
              py: "7px",
              px: "20px",
              borderRadius: "6px",
              fontSize: {lg:"14px", xs:'12px'},
            }}
            onClick={()=> setOpenAddChannelModal(true)}
          >
            <Add sx={{ fontSize: "20px", position: "relative", bottom: 1 }} />
            Add Channel
          </Button>
        </div>
      </div>

      <div className="mt-4">
     
          <ChannelList channels={channels}
          setChannels={setChannels} channelUpdatedModal = {channelUpdatedModal}
           setOpenChannelUpdatedModal={setOpenChannelUpdatedModal}/>
      </div>
    </div>
  );
};

export default Channels;


